import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput} from '../../components'
import container from '../../helpers/container'

import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'About'
    const url = config.domain + config.routes.about

    const bannerImage = 'park'
    const bannerHeadline = 'About Weapon Free Funds'
    const bannerSubtitle = 'How to avoid weapon investments'

    // const dfwLogo = require( '../../../static/images/dfw.svg' )
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )

    return (
      <div>
        {container.helmet(title, '', url)}
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>
        <div styleName='page aboutpage'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='double-logo-wrap'>
                <div styleName='double-logo'>
                  <div styleName='logo-first-wrap'>
                    <Link
                      to={config.links.ays}
                      title='As You Sow'
                      >
                      <img
                        styleName={'logo-ays'}
                        src={aysLogo}
                        alt='As You Sow'
                      />
                    </Link>
                  </div>
                  { /* <div styleName='logo-second-wrap'>
                    <Link
                      to={config.links.dfw}
                      title='Divest from the War Machine'>
                      <img
                        styleName={'logo-dfw'}
                        src={dfwLogo}
                        alt='Divest from the War Machine'
                      />
                    </Link>
                  </div> */ }
                </div>
              </div>
              <div styleName='title'>
                You may be invested in arms manufacturers and military contractors
              </div>

              <div styleName='lede'>
                You shouldn't have to be a financial expert to know how much
                of your savings are invested in unsustainable and morally
                problematic companies.
              </div>
            </div>
          </div>
          <div styleName='x-401k-container'>
            <div styleName='x-401k-container-inner'>
                <div styleName='x-401k-info-photo'>
                  <div
                    styleName='x-401k-photo'
                    title='401k retirement plans'
                  />
                  <div styleName='x-401k-info'>
                    <div styleName='x-401k-info-title'>
                      Responsible investing made easy
                    </div>
                    <p>
                      Weapon Free Funds is a search platform that enables you
                      to find out if your money, in the form of individual
                      mutual fund investments or an employer-provided 401(k),
                      is being used to finance makers of military weapons and
                      military contractors, and to find alternative options
                      that avoid weapon investments.
                    </p>
                    <p>
                      We can help build a more peaceful world by reducing the
                      power of those who profit from violence. Investors have
                      the power to cut ties with the corporations at the root
                      of militarism, and to reinvest in ethical companies that
                      support our communities and protect our planet.
                    </p>
                  </div>
                </div>
            </div>
          </div>
          <div styleName='x-ays-container'>
            <div styleName='x-ays-container-inner'>
              <div styleName='x-ays-info-photo'>
                <div
                  styleName='x-ays-photo'
                  title='As You Sow'
                />
                <div styleName='x-ays-info'>
                  <div styleName='x-ays-info-title'>
                    Who we are
                  </div>
                  <p>
                    For over two decades, As You Sow has promoted responsible
                    investment. As part of our <Link
                      to={config.links.aysinvest}
                      xstrong
                      title='As You Sow - Invest Your Values'
                    >
                      Invest Your Values program
                    </Link>, we've created a series of tools that provide free
                    information helping people invest fossil free,
                    deforestation free, weapon free, and more.
                  </p>
                  { /* <p>
                    To build Weapon Free Funds, As You Sow partnered
                    with <Link
                      to={config.links.dfw}
                      xstrong
                      title='Divest from the War Machine'
                    >
                      Divest from the War Machine
                    </Link>, a campaign from CODEPINK, a women-led grassroots
                    organization working to end U.S. wars and militarism,
                    support peace and human rights initiatives, and redirect
                    our tax dollars into healthcare, education, green jobs and
                    other life-affirming programs.
                  </p> */ }
                </div>
              </div>
            </div>
          </div>
          <div styleName='x-desktop-container'>
            <div styleName='x-desktop-container-inner'>
              <div styleName='x-desktop-info-photo'>
                <div
                  styleName='x-desktop-photo'
                  title='Your investments should align with your values'
                />
                <div styleName='x-desktop-info'>
                  <div styleName='x-desktop-info-title'>
                    How Weapon Free Funds works
                  </div>
                  <ul>
                    <li>Look up mutual funds using up-to-date Morningstar data</li>
                    <li>We analyze your investments for weapon stocks</li>
                    <li>See how much exposure they have to different weapon sectors</li>
                  </ul>
                  <p>
                    <Link
                      to={config.routes.howitworks}
                      xstrong
                      title='How it works'>
                        See how it works<LinkIcon />
                    </Link>
                  </p>
                  <div styleName='x-desktop-info-title'>
                    Use our action toolkit
                  </div>
                  <ul>
                    <li>Learn how to make a change and invest weapon free</li>
                    <li>Push your employer to provide weapon free 401(k) options</li>
                    <li>Find divestment resources for cities, universities, and more</li>
                  </ul>
                  <p>
                    <Link
                      to={config.routes.toolkit}
                      xstrong
                      title='Action toolkit'>
                        View the action toolkit<LinkIcon />
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <GetStartedInput />
        </div>
      </div>
    )
  }
}
